export interface MapProvider {
  getScript(): string;
  getName(): string;
  addToMap(map: L.Map): void;
}

export class MapProvider implements MapProvider {}
